import blockedEmailDomains from '@/constants/blockedEmailDomains';

const DOMAIN_REGEX =
  /^(((?!\\-))(xn\\-\\-)?[a-z0-9\-_]{0,63}[a-z0-9]{1,1}\.)*(xn\\-\\-)?([a-z0-9\\-]{1,63}|[a-z0-9\\-]{1,30})\.[a-zA-Z0-9]{2,}$/i;

export const isDomainValid = (domain: string) => {
  return (
    DOMAIN_REGEX.test(domain) && !domain.trim().startsWith('www.') && !domain.trim().startsWith('-')
  );
};

export const isURLPathStartsWithSlash = (url?: string) => {
  return (url ?? '').startsWith('/');
};

export const isURLPathStartsWithProtocol = (url?: string) => {
  return /^[a-zA-Z]+:\/\//.test(url ?? '');
};

export const isDomainValidForOpportunity = (domain: string) => {
  return DOMAIN_REGEX.test(domain) && !domain.trim().startsWith('-');
};

export const isBusinessEmail = (email: string) => {
  if (!email.includes('@')) {
    return false;
  }

  const emailDomain = email.split('@')[1].toLowerCase();
  return blockedEmailDomains.indexOf(emailDomain) === -1;
};

export const isSalesforceReportUrlValid = (url?: string) => {
  try {
    if (!url) {
      return true;
    }

    const sfUrl = new URL(url);
    const isReportPath = /^\/lightning\/r\/Report\//.test(sfUrl.pathname);
    const isSfHost = /lightning\.force\.com$/.test(sfUrl.hostname);
    return isReportPath && isSfHost;
  } catch {
    return false;
  }
};

export const isHubspotReportUrlValid = (url?: string) => {
  try {
    if (!url) {
      return true;
    }

    const hubspotUrl = new URL(url);
    const isHttpsProtocol = hubspotUrl.protocol === 'https:';
    const isHubspotHost = /\.hubspot\.com$/.test(hubspotUrl.hostname);

    // Validate HubSpot contacts list URL pattern
    // Pattern:
    // 1. /contacts/{number}/objectLists/{number}/filters?
    // 2. /contacts/{number}/objectLists/{number}/
    // 3. /contacts/{number}/objectLists/{number}
    const hubspotUrlPathPattern = /^\/contacts\/\d+\/objectLists\/\d+(?:\/filters)?\/?$/;
    const isHubspotPath = hubspotUrlPathPattern.test(hubspotUrl.pathname);
    return isHttpsProtocol && isHubspotHost && isHubspotPath;
  } catch {
    return false;
  }
};
